<template>
  <div>
    <app-gridview
      v-bind:parentData="{
        tabHeaders: this.dataHeader,
        tabItems: this.dataItems,
        pageTitle: this.pageTitle,
        search: this.search,
      }"
      v-on:EditItem="editItemHandler($event)"
      v-on:DeleteItem="deleteItemHandler($event)"
      v-on:NewPressed="newRecordHandler"
    ></app-gridview>
  </div>
</template>
<script>
//import moment from 'moment';

import GridView from "../../../components/common/GridView";

export default {
  components: {
    "app-gridview": GridView,
  },

  data() {
    return {
      pageTitle: this.$t('performancemanagement.kpiitem'),
      dataHeader: [
        { text: this.$t('columns.actions'), value: "action", sortable: false, width: "50px" },
        { text: this.$t('performancemanagement.goal'), value: "goal", width: "200px" },
        { text: this.$t('performancemanagement.kpi'), value: "kpi", width: "200px" },
        { text: this.$t('performancemanagement.weightage'), value: "weightage", width: "200px" },
        { text: this.$t('columns.type'), value: "pmkpitype", width: "200px" },
        { text: this.$t('pmkpiitem.kpifinalscorecalmethod'), value: "pmkpifinalscorecalmethod", width: "200px" },
        { text: this.$t('pmkpiset.subperiodcount'), value: "subperiodcount", width: "200px" },
        { text: this.$t('pmkpiitem.kpicategory'), value: "pmkpicatname", width: "200px" },
        { text: this.$t('Setupratingscaleset.ratingset'), value: "rateset", width: "200px" },
        { text: this.$t('pmkpiitem.basedonpercentage'), value: "basedonpercentagetext", width: "200px" },
      ],
      dataItems: [],
      loading: false,
      errMsg: "",
      search: this.$route.params.search,
    };
  },

  methods: {
    getKpiItemHandler() {
      const vm = this;

      this.loading = !this.loading;

      this.$store.dispatch('get', {url: "/kpiitem/all"})
        .then(function (res) {
          vm.dataItems = res.data.rec;

          vm.loading = !vm.loading;

        })
        .catch(function (err) {
          vm.errMsg = err;
        });
    },

    editItemHandler(item) {
      this.$router.push({ name: "kpiitemedit", params: { id: item.id, search: item.search  } });
    },

    newRecordHandler() {
      this.$router.push({ name: "kpiitemnew" });
    },
  },

  mounted() {
    this.getKpiItemHandler();
  },
};
</script>